import { hot } from 'react-hot-loader/root';
import { template } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import PageSection from '../components/PageSection';
import OnboardingSplash from '../components/OnboardingSplash';
import onboardPropTypes from '../proptypes/onboard-splash';

const selectIntroText = (referrerName, { introWithReferrerName, intro }) => (
  referrerName
    ? template(introWithReferrerName)({ referrer_name: referrerName })
    : intro
);

const ReferralOnboardingSplashPage = (props) => {
  const {
    referrerName,
    phrases: {
      splash: splashPhrases,
      referralSplash: referralSplashPhrases,
    },
  } = props;
  return (
    <PageSection theme="black">
      <OnboardingSplash
        intro={selectIntroText(referrerName, referralSplashPhrases)}
        {...props}
        phrases={splashPhrases}
      />
    </PageSection>
  );
};

ReferralOnboardingSplashPage.defaultProps = {
  referrerName: null,
};

ReferralOnboardingSplashPage.propTypes = {
  ...onboardPropTypes,
  referrerName: PropTypes.string,
  phrases: PropTypes.exact({
    splash: onboardPropTypes.phrases.isRequired,
    referralSplash: PropTypes.exact({
      introWithReferrerName: PropTypes.string.isRequired,
      intro: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default hot(ReferralOnboardingSplashPage);
